/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import moment from 'moment';
import { actions } from '../../actions/publicSurveyActions';
import { actions as authActions } from '../../actions/authActions';
import { actions as cmsActions } from '../../actions/cmsActions';
import Attachments from './Attachments';
import Photos from './Photos';
import LoadingIndicator from '../LoadingIndicator';
import PublicSurveySubmissionDetails from './PublicSurveySubmissionDetails';
import ActComments from './ActComments';
import UserInfoPanel from '../auth/UserInfoPanel';
import { SurveyStatuses } from '../../models/survey/SurveyStatuses';
import { ParticipantOrganizationTypes } from '../../models/auth/ParticipantOrganizationTypes';
import { ParticipantVerificationStatus } from '../../models/auth/ParticipantVerificationStatus';
import { Typography, Dialog, DialogActions, DialogTitle, DialogContent, Button } from '@material-ui/core';
import BoardThreads from './board/BoardThreads';


class PublicSurveySubmissionPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { displayErrorDialog: false };
  }

  componentDidMount() {
    this.props.actions.getDetails(this.props.match.params.id);
    this.props.cmsActions.retrieveUnitLocation();

  }

  getContent = (type, content) => {
    if (type === 'zipx') return content;
    let number = 1;
    return content.replace(/<p/g, () => (`<p id="block${number++}"`));
  }

  validatePariticipationConstraints(organizationType) {
    if (!this.props.survey.participationConstraints.requireCompany && !this.props.survey.participationConstraints.requireNonGovernmentOrganization && !this.props.survey.participationConstraints.requireSubordinateOrganization) return true;

    let isValid = false;
    if (this.props.survey.participationConstraints.requireCompany && organizationType === ParticipantOrganizationTypes.company) isValid = true;
    if (this.props.survey.participationConstraints.requireNonGovernmentOrganization && organizationType === ParticipantOrganizationTypes.nonGovernment) isValid = true;
    if (this.props.survey.participationConstraints.requireSubordinateOrganization && organizationType === ParticipantOrganizationTypes.subordinate) isValid = true;

    return isValid;
  }

  handleSubmit = (id, data) => {
    return this.props.actions.submitSurvey(id, data)
      .then(result => {
        if (result && result.status === 400) {
          if (result.data.validationErrors && result.data.validationErrors.some(v => v.errorMessage === "Dane respondenta zostały już wykorzytane")) {
            this.setState({ errorMessage: "Wpisane dane respondenta zostały już wcześniej wykorzystane w tej ankiecie." });
            this.setState({ displayErrorDialog: true });
          } else if (result.data.type === "domainValidation") {
            if (result.data.message === "Responder rejected") {
              this.setState({ errorMessage: 'Mieszkańcu nie zostałeś zidentyfikowany. Być może zrobiłeś "literówkę", spróbuj ponownie. Jeżeli to nie przyniesie efektu prosimy o kontakt z Urzędem - dane kontaktowe dostępne są w zakładce "Kontakt" na stronie głównej portalu.' });
            } else if (result.data.message === "Already voted") {
              this.setState({ errorMessage: "Wpisane dane respondenta zostały już wcześniej wykorzystane w tej ankiecie." });
            } else if (result.data.message === "Phone verification error") {
              this.setState({ errorMessage: "Podano nieprawidłowy kod weryfikacyjny SMS." });
            }
            
            this.setState({ displayErrorDialog: true });
          }
        }
      });
  }

  render() {
    const { fetching, survey, cms, preview, userSignedIn, account, auth, unit, actions } = this.props;
    const satisfyingParticipationConstraints = survey != null
      && (!survey.participationConstraints.requireVerification || (account && account.verificationStatus === ParticipantVerificationStatus.verified))
      && (account && this.validatePariticipationConstraints(account.organizationType));

    return (
      <div style={{ padding: 16 }}>
        <LoadingIndicator fetching={fetching}>
          {survey &&
            <React.Fragment>
              <div className="row top">
                <div className="col-sm-2" />
                <div className="col-sm-3" />
                <div className="col-sm-7 header">
                  {survey.authenticationRequired || survey.boardSettings.enabled || (auth && auth.signedIn) ? <UserInfoPanel auth={auth}
                    authenticationRequired={survey.authenticationRequired} authActions={this.props.authActions} account={this.props.account} /> : null}
                  <a href="/konsultacje-spoleczne" className="btn"><i className="fa fa-long-arrow-alt-left" /> lista konsultacji</a>
                </div>
              </div>

              {!survey.authenticationRequired && auth && auth.signedIn
                ? <div>
                    <div className="row">
                      <div className="box">
                        <div className="col-sm-12">
                          <strong>Konsultacje otwarte. Jeśli chcesz wziąć udział anonimowo - wyloguj się</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                : null}

              <div>
                <div className="row">
                  <div className="box">
                    <div className="col-sm-12">
                      <h2>{survey.name}</h2>
                      <ul className="date">
                        {survey.activeFrom && <li className="date_from"><i className="far fa-clock" /> <span>Data rozpoczęcia</span> {moment(survey.activeFrom).format('D MMMM YYYY HH:mm')}</li>}
                        {survey.activeTo && <li className="date_to"><i className="far fa-clock" /> <span>Data zakończenia</span> {moment(survey.activeTo).format('D MMMM YYYY HH:mm')}</li>}
                      </ul>
                      <div dangerouslySetInnerHTML={{ __html: survey.description }} />
                      {survey.additionalDescriptions && survey.additionalDescriptions.map(description => (
                        <div key={description.name} className="row inner-content">
                          <div className="col-xs-12 wrapper">
                            <h3>{description.name}</h3>
                            <div dangerouslySetInnerHTML={{ __html: description.description }} />
                          </div>
                        </div>)
                      )}
                      {survey.participationConstraints.requireVerification || survey.participationConstraints.requireNonGovernmentOrganization || survey.participationConstraints.requireSubordinateOrganization
                        ? <React.Fragment>
                          <Typography variant="subtitle2" component="p" color="primary">{`Konsultacje dostępne są wyłącznie dla:`}</Typography>
                          {survey.participationConstraints.requireVerification && <Typography variant="subtitle2" component="p" color="primary">- zweryfikowanych kont</Typography>}
                          {survey.participationConstraints.requireNonGovernmentOrganization && <Typography variant="subtitle2" component="p" color="primary">- organizacji pozarządowych</Typography>}
                          {survey.participationConstraints.requireSubordinateOrganization && <Typography variant="subtitle2" component="p" color="primary">- jednostek podległych</Typography>}
                          {survey.participationConstraints.requireCompany && <Typography variant="subtitle2" component="p" color="primary">- firm</Typography>}
                          {userSignedIn && !satisfyingParticipationConstraints ? <Typography variant="body2" component="p" color="error" style={{ marginTop: 10 }}>Twoje konto nie zostało jeszcze zweryfikowane lub udział w konsultacjach wymaga innego typu konta</Typography> : null}
                        </React.Fragment>
                        : null}
                    </div>
                  </div>
                </div>

                {!survey.attachments || !survey.attachments.length ? null :
                  <Attachments
                    attachments={survey.attachments}
                    unit={unit}
                  />}

                {!survey.photos || !survey.photos.length ? null :
                  <Photos
                    photos={survey.photos}
                    onClick={fileId => this.props.actions.openFile(fileId)}
                    unit={unit}
                  />}

                {survey.boardSettings.enabled
                  ? <div className="row">
                    <div className="box-header-outside">
                      <div className="col-sm-12">
                        <div className="header">
                          <h2>Forum</h2>
                        </div>
                      </div>
                    </div>
                    <div className="box">
                      <div className="col-sm-12">
                        <BoardThreads
                          surveyId={survey.id}
                          readonly={survey.boardSettings.readonly}
                          preview={preview}
                          satisfyingParticipationConstraints={satisfyingParticipationConstraints}
                          authenticationRequired={survey.authenticationRequired}
                          boardSettings={survey.boardSettings}
                        />
                      </div>
                    </div>
                  </div>
                  : null}

                {survey.consultedAct
                  ? <div className="row">
                    <div className="box-header-outside">
                      <div className="col-sm-12">
                        <div className="header">
                          <h2>Formularz komentowania</h2>
                        </div>
                      </div>
                    </div>
                    <div className="box">
                      <div className="col-sm-12">
                        <ActComments
                          content={this.getContent(survey.consultedAct.type, survey.consultedAct.content)}
                          authenticationRequired={survey.authenticationRequired}
                          userSignedIn={userSignedIn && satisfyingParticipationConstraints}
                          userId={this.props.auth.id}
                          onSave={(text, blockId, commentedParagraph) => this.props.actions.addComment(survey.id, { text, blockId, commentedParagraph })}
                          comments={survey.comments}
                          preview={preview}
                        />
                      </div>
                    </div>
                  </div>
                  : null}

                {survey.form.length > 0 && cms.location ? <PublicSurveySubmissionDetails
                  readonly={preview || (survey.authenticationRequired && (!userSignedIn || !satisfyingParticipationConstraints))}
                  form={survey.form}
                  respondentProfile={survey.respondentProfile}
                  approvals={survey.approvals}
                  surveyId={survey.id}
                  onSubmit={this.handleSubmit}
                  onDeleteUploadedFile={actions.deleteSubmissionTemporaryFile}
                  tenantName={cms.fullName}
                  proposedLocations={survey.proposedLocations}
                  initialLocation={cms.location.ok ? cms.location : null}
                  unit={unit}
                  participantsVerification={survey.participantsVerification}
                  identificationMethods={survey.voterIdentificationMethods}
                  actions={actions}
                /> : null}
              </div>
              <Dialog open={this.state.displayErrorDialog} aria-labelledby="dialog-title" maxWidth="md">
                <DialogTitle id="dialog-title">Uwaga</DialogTitle>
                <DialogContent>
                  <Typography variant="subtitle1">{this.state.errorMessage}</Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => this.setState({ displayErrorDialog: false })} color="primary" variant="contained">
                    Ok
                  </Button>
                </DialogActions>
              </Dialog>
            </React.Fragment>}
        </LoadingIndicator>
      </div>
    );
  }
}

PublicSurveySubmissionPage.propTypes = {
  t: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
  authActions: PropTypes.object.isRequired,
  cmsActions: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  fetching: PropTypes.bool.isRequired,
  survey: PropTypes.object,
  location: PropTypes.object.isRequired,
  cms: PropTypes.object.isRequired,
  userSignedIn: PropTypes.bool,
  auth: PropTypes.object,
  preview: PropTypes.bool,
  account: PropTypes.object,
  unit: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    fetching: state.publicSurveyDetails.fetching,
    survey: state.publicSurveyDetails.data,
    cms: state.cms,
    userSignedIn: state.auth.signedIn,
    auth: state.auth,
    preview: window.location.href.includes('podglad') || (state.publicSurveyDetails.data && state.publicSurveyDetails.data.status !== SurveyStatuses.open),
    account: state.account.data,
    unit: state.unit,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
    cmsActions: bindActionCreators(cmsActions, dispatch),
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(PublicSurveySubmissionPage);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/PublicSurveySubmissionPage.js